import { render, staticRenderFns } from "./orderContact.vue?vue&type=template&id=47901c45&"
import script from "./orderContact.vue?vue&type=script&lang=js&"
export * from "./orderContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports